import { PhoneVoice } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';
import { rolesFor } from '@/features/assistant/permissions';

/**
 * Голосовой бот AI-администратора (АДМ-70…74, Приложение D): журнал звонков, «перезвонить», статистика — роли с
 * доступом к диалогам и дашборду обращений; настройки и песочница — роли с доступом к настройкам AI-администратора.
 */
const roles = [...new Set([...rolesFor('conversations'), ...rolesFor('assistant_settings'), ...rolesFor('dashboard_requests')])];

export const section = defineSection({
  id: 'voice.bot',
  area: 'clinic',
  path: 'voice/*',
  roles,
  icon: PhoneVoice,
  titleKey: 'voice:title',
  namespaces: ['analytics', 'portal'],
  navGroup: 'work',
  order: 70,
  navTitleKey: 'voice:nav.calls',
  load: () => import('./VoicePage'),
});
